import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './Shared/components/toast/toast.component';
import { GlobalLoaderComponent } from './Shared/components/global-loader/global-loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, GlobalLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  socket!: WebSocket;

  ngOnInit(): void {
    // this.connect('ws://localhost:2001');
  }

  connect(url: string): void {
    this.socket = new WebSocket(url);
    // Handle incoming messages
    this.socket.onmessage = (event) => {};
    // Handle connection open
    this.socket.onopen = () => {
      console.log('WebSocket connection established');
    };
    // Handle connection close
    this.socket.onclose = () => {
      console.log('WebSocket connection closed');
    };
    // Handle errors
    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  }

  title = 'POS';
}
